import { create } from 'zustand';

export const useStore = create((set, get) => ({
  // Price deck state
  priceDeck: 75,
  setPriceDeck: (price) => set({ priceDeck: price }),
  
  // Selected entities
  selectedOperator: null,
  setSelectedOperator: (operator) => set({ selectedOperator: operator }),
  
  selectedCounty: null,
  setSelectedCounty: (county) => set({ selectedCounty: county }),
  
  selectedWell: null,
  setSelectedWell: (well) => set({ selectedWell: well }),
  
  // Data loading states
  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading }),
  
  // Last update timestamp
  lastUpdate: null,
  setLastUpdate: (timestamp) => set({ lastUpdate: timestamp }),
  
  // Basin overview data
  basinData: null,
  setBasinData: (data) => set({ basinData: data }),
  
  // Operators data
  operators: [],
  setOperators: (operators) => set({ operators }),
  
  // Counties data
  counties: [],
  setCounties: (counties) => set({ counties }),
  
  // Wells data
  wells: [],
  setWells: (wells) => set({ wells }),
  
  // Sidebar state - collapsed by default for mobile-first
  sidebarOpen: false,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  
  // Active view
  activeView: 'dashboard',
  setActiveView: (view) => set({ activeView: view }),
  
  // Refresh interval (60 seconds)
  refreshInterval: 60000,
  
  // Error state
  error: null,
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
}));
